import { AutocompleteRenderInputParams, styled, TextField } from '@mui/material';

interface AutocompleteInputProps {
  params: AutocompleteRenderInputParams;
  placeholder: string;
  testIdSuffix?: string;
}

const StyledInputField = styled(TextField)(({ theme }) => ({
  '& .MuiAutocomplete-root': {
    padding: 0,
    minHeight: '36px',
    height: 'auto',
  },
  '& .MuiOutlinedInput-root': {
    fontSize: 14,
    padding: '0 6px !important',
    borderRadius: '4px',
    '&.Mui-focused': {
      boxShadow: `0 0 0 2px ${theme.palette.background.paper}, 0 0 0 4px ${theme.hhglobal.brand.secondary.pumpkinOrange}`,
      fieldset: {
        borderColor: theme.hhglobal.neutral.gray300,
        borderRadius: '4px',
      },
    },
  },
  '& .MuiInputBase-input': {
    padding: '4px 0',
    minWidth: '120px',
  },
}));

function AutocompleteInput(props: AutocompleteInputProps) {
  return (
    <>
      <StyledInputField
        {...props.params}
        placeholder={props.placeholder}
        slotProps={{
          ...props.params.slotProps,
          htmlInput: {
            ...props.params.slotProps.htmlInput,
            'data-testid': props.testIdSuffix ? `base-multi-autocomplete-input-${props.testIdSuffix}` : 'base-multi-autocomplete-input',
          },
        }}
      />
    </>
  );
}

export default AutocompleteInput;
